import { firstValueFrom } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppConfig } from './shared/app-config';

@Injectable()
export class AppConfigService {
  private readonly _httpHandler = inject(HttpBackend);
  private readonly _http: HttpClient = new HttpClient(this._httpHandler);
  private _loadAppConfigPromise?: Promise<unknown>;

  loadAppConfig(): Promise<unknown> {
    this._loadAppConfigPromise ??= firstValueFrom(
      this._http.get(`/assets/appConfig.json`).pipe(
        tap((environmentConfig) => {
          Object.assign(AppConfig, environmentConfig);
        })
      )
    ).catch((error) => {
      this._loadAppConfigPromise = undefined;
      throw error;
    });

    return this._loadAppConfigPromise;
  }
}
